export const BACKGROUND_CLICK_REASON = 'backdropClick';
